export class CostType {
  id: number = null;
  type?: string = null;
  description?: string = null;
}
